export enum PageType {
  MainPage = 1,
  Registration = 2,
  LogIn = 3
}
